import { cn } from "../../utils/classnames.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@base-ui/react/scroll-area";
// src/components/molecules/scroll-area.tsx
const ScrollBar = ({ className, orientation = "vertical", ...props }) => {
	return /* @__PURE__ */ jsx(ScrollArea.Scrollbar, {
		className: cn(`
          m-1
          data-[orientation=horizontal]:h-1.5
          data-[orientation=vertical]:w-1.5
          flex opacity-0 transition-opacity delay-300
          data-hovering:opacity-100 data-hovering:delay-0 data-hovering:duration-100
          data-scrolling:opacity-100 data-scrolling:delay-0 data-scrolling:duration-100
          data-[orientation=horizontal]:flex-col
        `, className),
		"data-slot": "scroll-area-scrollbar",
		orientation,
		...props,
		children: /* @__PURE__ */ jsx(ScrollArea.Thumb, {
			className: "bg-foreground/20 relative flex-1 rounded-full",
			"data-slot": "scroll-area-thumb"
		})
	});
};
const ScrollArea$1 = ({ className, children, scrollFade = false, scrollbarGutter = false, ...props }) => {
	return /* @__PURE__ */ jsxs(ScrollArea.Root, {
		className: cn("min-h-0 size-full", className),
		...props,
		children: [
			/* @__PURE__ */ jsx(ScrollArea.Viewport, {
				className: cn(`
            focus-visible:ring-ring focus-visible:ring-offset-background
            h-full max-h-[inherit] rounded-[inherit] transition-shadow outline-none
            focus-visible:ring-2 focus-visible:ring-offset-1
            data-has-overflow-x:overscroll-x-contain
            data-has-overflow-y:overscroll-y-contain
          `, scrollFade && `
              mask-t-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-y-start)))]
              mask-r-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-x-end)))]
              mask-b-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-y-end)))]
              mask-l-from-[calc(100%-min(var(--fade-size),var(--scroll-area-overflow-x-start)))]
              [--fade-size:1.5rem]
            `, scrollbarGutter && "data-has-overflow-y:pe-2.5 data-has-overflow-x:pb-2.5"),
				"data-slot": "scroll-area-viewport",
				children
			}),
			/* @__PURE__ */ jsx(ScrollBar, { orientation: "vertical" }),
			/* @__PURE__ */ jsx(ScrollBar, { orientation: "horizontal" }),
			/* @__PURE__ */ jsx(ScrollArea.Corner, { "data-slot": "scroll-area-corner" })
		]
	});
};
export { ScrollArea$1 as ScrollArea, ScrollBar };

//# sourceMappingURL=scroll-area.js.map